import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { convertToRaw, EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import CtaLink from './CustomOptions/CtaLink';

interface Props {
  textContent: string;
  setFieldValue: (name: string, value: string) => void;
}

const EditorText = ({ textContent, setFieldValue }: Props) => {
  if (textContent === '') return null;

  const contentBlock = htmlToDraft(textContent);

  const contentState = ContentState.createFromBlockArray(
    contentBlock.contentBlocks
  );
  const editorState = EditorState.createWithContent(contentState);

  const styleMap = {
    STRIKETHROUGH: {
      textDecoration: 'line-through',
    },
    redBackground: {
      backgroundColor: 'red',
    },
    greenBackground: {
      backgroundColor: 'green',
    },
  };

  const toolbar = {
    options: [
      'inline',
      'blockType',
      'fontSize',
      'fontFamily',
      'list',
      'textAlign',
      'colorPicker',
      'link',
      'emoji',
    ],
  };
  return (
    <Editor
      customStyleMap={styleMap}
      toolbar={toolbar}
      /* eslint-disable-next-line */
      toolbarCustomButtons={[<CtaLink />]}
      defaultEditorState={editorState}
      onEditorStateChange={(editorState: any) => {
        const state = editorState.getCurrentContent();
        const raw = convertToRaw(state);

        const html = draftToHtml(raw);

        setFieldValue('text_content', html);
      }}
    />
  );
};

export default EditorText;
